import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, of, switchMap } from 'rxjs';

import { ElasticService } from '@offconon/core-api';

import * as ElasticSearchBoxActions from './elastic-search-box.actions';

@Injectable()
export class ElasticSearchBoxEffects {
  private actions$ = inject(Actions);
  private elasticService = inject(ElasticService);
  private store = inject(Store);

  getSearchResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ElasticSearchBoxActions.getSearchResults),
      switchMap((action) => {
        if (action && action.platform === 'core') {
          return this.elasticService
            .elasticPublicSearchCreate(action.searchJson, action.page, action.pageSize)
            .pipe(
              switchMap((storage) => {
                return of(
                  ElasticSearchBoxActions.getSearchResultsSuccess({ searchResults: storage }),
                );
              }),
              catchError((error) => {
                return of(ElasticSearchBoxActions.getSearchResultsFailure({ error }));
              }),
            );
        }
        if (action && action.platform === 'erp') {
          return this.elasticService
            .elasticBusinessSearchCreate(action.searchJson, action.page, action.pageSize)
            .pipe(
              switchMap((storage) => {
                return of(
                  ElasticSearchBoxActions.getBusinessSearchResultsSuccess({
                    searchBusinessResults: storage,
                  }),
                );
              }),
              catchError((error) => {
                return of(ElasticSearchBoxActions.getSearchResultsFailure({ error }));
              }),
            );
        } else {
          return EMPTY;
        }
      }),
    ),
  );
  getPaginatedSearchResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ElasticSearchBoxActions.getPaginatedSearchResults),
      switchMap((action) => {
        if (action && action.platform === 'core') {
          return this.elasticService
            .elasticPublicSearchCreate(action.searchJson, action.page, action.pageSize)
            .pipe(
              switchMap((storage) => {
                return of(
                  ElasticSearchBoxActions.getPaginatedSearchResultsSuccess({
                    searchResults: storage,
                  }),
                );
              }),
              catchError((error) => {
                return of(ElasticSearchBoxActions.getSearchResultsFailure({ error }));
              }),
            );
        }
        if (action && action.platform === 'erp') {
          return this.elasticService
            .elasticBusinessSearchCreate(action.searchJson, action.page, action.pageSize)
            .pipe(
              switchMap((storage) => {
                return of(
                  ElasticSearchBoxActions.getPaginatedBusinessSearchResultsSuccess({
                    searchBusinessResults: storage,
                  }),
                );
              }),
              catchError((error) => {
                return of(ElasticSearchBoxActions.getSearchResultsFailure({ error }));
              }),
            );
        } else {
          return EMPTY;
        }
      }),
    ),
  );
}
